import { toast } from '@huspy/forge/shared';
import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { useShallowEffect } from '@mantine/hooks';
import { ProposalStatus } from '@modules/clients/entities/client/api/dto/clientProposal.dto';
import { formatToLocalTimeZone } from '@shared/utils';
import { proposalApi } from '@modules/proposals/api';
import useFeatureFlags from '@modules/core/hooks/useFeatureFlags';
import { ProposalsSearchParams } from '@modules/proposals/api/dto/proposals.dto';

export const useProposalsListAE = (q: ProposalsSearchParams) => {
  const [query, setQuery] = useState<ProposalsSearchParams>(q);
  const { isFeatureActive, isFeatureFlagsLoading } = useFeatureFlags();

  const {
    data, isLoading, error, refetch, isRefetching,
  } = useQuery({
    queryKey: ['proposalsList', query],
    queryFn: () => proposalApi.getProposals(query),
    select: (_data) => ({
      ..._data,
      proposals: _data.proposals.map((proposal) => ({
        ...proposal,
        editable_until: proposal.editable_until
          ? formatToLocalTimeZone(proposal.editable_until).toISOString() : proposal.editable_until,
        state: proposal.status
          ?? (proposal.bank_offers && proposal.bank_offers?.length > 0
            ? ProposalStatus.GENERATED
            : ProposalStatus.DRAFT),
      })),
    }),
    staleTime: 0,
    enabled: !isFeatureFlagsLoading && isFeatureActive('proposals.module') && !isFeatureActive('proposals.baytecaMVP'),
  });

  useEffect(() => {
    if (error) {
      toast('error', { message: error.message });
    }
  }, [error]);

  // https://mantine.dev/hooks/use-shallow-effect/
  useShallowEffect(() => {
    setQuery(q);
  }, [q]);

  return {
    data,
    isLoading,
    error,
    refetch,
    isRefetching,
  };
};
